import React from "react";
import Image from "next/image";
import { ValeurProps } from ".";

const Valeur: React.FC<ValeurProps> = ({ titre, image, description }) => {
  return (
    <div className="card flex min-h-max min-w-max flex-row items-center space-x-4 lg:max-w-md lg:flex-col">
      <div className="relative flex h-16 w-16 items-center justify-center rounded-full bg-whiteAccent lg:mb-6">
        <Image alt={`Icone ${titre}`} src={image} layout="fixed" height={35} width={35} />
      </div>
      <div className="flex flex-col space-y-2">
        <h6 className="text-lg font-bold uppercase leading-5 text-redAccent lg:text-center lg:text-2xl">{titre}</h6>
        <p className="flex text-xs lg:justify-center lg:text-center">
          <ul>
            {description.map((val, key) => (
              <li key={key}>{val}</li>
            ))}
          </ul>
        </p>
      </div>
    </div>
  );
};

export default Valeur;
